import React from "react";
import OfferingsCheckboxListFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsCheckboxListFilters/OfferingsCheckboxListFilters";
var MandateOrderStatusFilters = function (props) {
    // *******************************************
    // *           Constants                     *
    // *******************************************
    var _a;
    var checkboxDataList = [
        {
            label: "In Process Orders",
            value: "inProcess",
            isAccordionOpenByDefault: false,
            subList: [
                {
                    label: "Document not uploaded",
                    value: "Document not uploaded",
                    parentFilterValue: "inProcess",
                    parentFilterLabel: "In Process Orders",
                },
                {
                    label: "Processing",
                    value: "Processing",
                    parentFilterValue: "inProcess",
                    parentFilterLabel: "In Process Orders",
                },
                {
                    label: "Registration pending",
                    value: "Registration pending",
                    parentFilterValue: "inProcess",
                    parentFilterLabel: "In Process Orders",
                },
            ],
        },
        {
            label: "Active Orders",
            value: "Active",
        },
        {
            label: "Inactive & Failed Orders",
            value: "inactiveFailed",
            isAccordionOpenByDefault: false,
            subList: [
                {
                    label: "Registration Failed",
                    value: "Registration Failed",
                    parentFilterValue: "inactiveFailed",
                    parentFilterLabel: "Inactive & Failed Orders",
                },
                {
                    label: "Inactive",
                    value: "Inactive",
                    parentFilterValue: "inactiveFailed",
                    parentFilterLabel: "Inactive & Failed Orders",
                },
                {
                    label: "Cancelled",
                    value: "Cancelled",
                    parentFilterValue: "inactiveFailed",
                    parentFilterLabel: "Inactive & Failed Orders",
                },
            ],
        },
    ];
    return (React.createElement("div", { className: "".concat((_a = props.parentClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement(OfferingsCheckboxListFilters, { displayDataList: checkboxDataList, parentKeyName: "dpStatus", onChangeCallback: function (data) {
                (props === null || props === void 0 ? void 0 : props.handleFilterChangeCallback) &&
                    (props === null || props === void 0 ? void 0 : props.handleFilterChangeCallback(data));
            }, selectedValuesList: props.selectedFiltersData })));
};
export default MandateOrderStatusFilters;
